import { memo } from 'react';
import { AlertTriangleIcon } from '@page/icons';

import { SectionPlaceholder } from './SectionPlaceholder';
import { LinkButton } from '../../designSystem/LinkButton';
import { CONTACT_EMAIL } from '@page/core/config';

export interface SectionErrorPlaceholderProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  useReport?: boolean;
  className?: string;
  onActionClick?: () => void;
}

const SectionErrorPlaceholderBase = ({
  title = 'Something went wrong',
  description = 'There was an error while loading the section. Please try again later.',
  action = 'Try again',
  useReport = false,
  className,
  onActionClick,
}: SectionErrorPlaceholderProps) => {
  const handleReport = () => {
    const reportButton = document.getElementById('report-issue-button');

    reportButton?.click();
  };

  return (
    <SectionPlaceholder
      className={className}
      icon={<AlertTriangleIcon className="size-14 fill-icon-warning" />}
      title={title}
      description={description}
      action={action}
      onActionClick={onActionClick}
      actionSubtitle={
        <div className="flex gap-3 text-text-primary font-body-md dark:text-white">
          <div className="font-medium">Need help?</div>
          {useReport ? (
            <LinkButton onClick={handleReport}>Report issue</LinkButton>
          ) : (
            <LinkButton element="a" href={`mailto:${CONTACT_EMAIL}`}>
              Contact us
            </LinkButton>
          )}
        </div>
      }
    />
  );
};

export const SectionErrorPlaceholder = memo(SectionErrorPlaceholderBase);
